/* eslint-disable no-unused-vars */






import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';

import { MdPayment, MdEmail } from 'react-icons/md';

import { loadStripe } from '@stripe/stripe-js' 
import { Elements } from '@stripe/react-stripe-js' 

import { place_order } from './../store/reducers/orderReducer';
import { get_cart_products, get_wishlist_products } from '../store/reducers/cartReducer';

import GetSellerConfig from '../components/GetSellerConfig';

import axios from 'axios';
import CheckoutForm from './CheckoutForm';
import error from '../assets/error.png'
import success from '../assets/success.png'
import config from '../config';

const Stripe = ({price, products, eventDetailsInfo, isDeposit, isBalance }) => {
    const sellerBackendURL = config.STR_BACKEND_URL
    //const sellerEnivronment = config.STR_ENVIRONMENT
    const sellerEnvironment = config.STR_ENVIRONMENT
    // orderId, console.log('Stripe.jsx sellerBackendURL ', sellerBackendURL, 'sellerEnivronment ', sellerEnivronment)
    
    const { userInfo } = useSelector(state => state.auth) 
    const { seller } = useSelector(state => state.seller)
    const dispatch = useDispatch()
    
    const customerId = userInfo.id
    const customerName = userInfo.name
    const customerEmail =userInfo.email
    const customerPhone = userInfo.phoneNumber
    // console.log('Stripe.jsx seller ', seller)
    // console.log('userInfo ', userInfo)
    
    const { 
        sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
        sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
        sellerColorDark, sellerColorMedium, sellerColorLight,
        sellerStripePaymentMode, sellerBoolShowSitePayments, 
    } = GetSellerConfig();

    let stripePublishableKey = '' 

    if (sellerEnvironment === 'Prod') {
        // stripePublishableKey = seller.stripeLivePublishableKey  
        if (sellerStripePaymentMode === 'Live') {
            
            stripePublishableKey = seller.stripeLivePublishableKey
        } else if (sellerStripePaymentMode === 'Test') {
            //stripeSecretKey = seller.stripeTestSecretKey
            stripePublishableKey = seller.stripeTestPublishableKey
        }
    } else if (sellerEnvironment === 'Dev') {
        stripePublishableKey = seller.stripeTestPublishableKey
    }

    const stripePromise = loadStripe(stripePublishableKey)

    let sellerBoolDepositShowPayments = false
    if (sellerBoolShowSitePayments) {
        sellerBoolDepositShowPayments = true
    } else if (!sellerBoolShowSitePayments) {
        //console.log('isDeposit ', isDeposit)
        sellerBoolDepositShowPayments = false
        if (isDeposit || isBalance) { // === 'true'
            sellerBoolDepositShowPayments = true
            //console.log('sellerBoolDepositShowPayments ', sellerBoolDepositShowPayments)
        }
    }
    
    // console.log('sellerBoolDepositShowPayments ', sellerBoolDepositShowPayments, 
    //     '\nisDeposit ', isDeposit, 
    //     '\nsellerBoolShowSitePayments ', sellerBoolShowSitePayments)

    const get_cart_products_local = () => {
        dispatch(get_cart_products(userInfo.id))    
    };

    useEffect(() => {
        if (sellerBoolDepositShowPayments === false) {
            // console.log('place_order_local\n')
            // console.log('price ', price)
            // console.log('products ', products)
            // console.log('eventDetailsInfo', eventDetailsInfo)
            // dispatch(place_order({
            //     customerId, customerName, customerEmail, customerPhone, orderType: 'Menu Order',
            //     price, products, eventDetailsInfo 
            // }))
        }   
    })

    const place_order_local = () => {
        //console   
        if (sellerBoolDepositShowPayments === false) {
            // console.log('place_order_local\n')
            // console.log('price ', price)
            // console.log('products ', products)
            // console.log('eventDetailsInfo', eventDetailsInfo)
            // dispatch(place_order({
            //     customerId, customerName, customerEmail, customerPhone, orderType: 'Menu Order',
            //     price, products, eventDetailsInfo       
            // })) 
        }
    }

    // if sellerBoolDepositShowPayments === false
    // console.log('sellerBoolDepositShowPayments ', sellerBoolDepositShowPayments, '\nisDeposit ', isDeposit, 
    //     '\nsellerBoolShowSitePayments ', sellerBoolShowSitePayments)
        
    const [clientSecret, setClientSecret] = useState('')
    const appearance    = {
        theme: 'stripe'
    }
    const options = {
        appearance,
        clientSecret
    }
    
    const create_payment = async () => {
        try {
            //const { data } = await axios.post('http://localhost:5000/api/order/create-payment', {price}, {withCredentials:true})
            //const { data } = await axios.post(`${config.STR_BACKEND_URL}/api/order/create-payment`, {price}, {withCredentials:true})
            const { data } = await axios.post(`${sellerBackendURL}/api/order/create-payment`, {price, sellerId, sellerEnvironment}, {withCredentials:true})
            //console.log(data)
            setClientSecret(data.clientSecret)
        } catch (error) {
            console.log(error.response.data)
        }
    }

    return (
        <div className='mt-1'>
            { //orderId={orderId} 
                clientSecret ? (
                    <Elements options={options} stripe={stripePromise}>
                        <CheckoutForm price={price} products={products} eventDetailsInfo={eventDetailsInfo} 
                            isDeposit={isDeposit} isBalance={isBalance} stripePublishableKey={stripePublishableKey} />
                    </Elements>
                ) 
                : 
                //BOOL_SHOW_PAYMENTS sellerBoolDepositShowPayments
                //         stripePublishableKey: {stripePublishableKey}<br/>
                //         clientSecret: {clientSecret}
                // px-10 py-[6px] m-2 rounded-lg hover:shadow-green-700/30 hover:shadow-lg bg-green-700 text-white
                // px-10 py-[6px] font-semibold border-2 rounded-lg hover:shadow-green-700/30 hover:shadow-lg text-white
                // style={{color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1, borderColor:sellerPrimaryColor1}}
                <div>
                    <button onClick={create_payment}
                        className={` ${sellerBoolDepositShowPayments ? '' : 'hidden'} 
                        flex gap-1 px-10 py-[6px] m-2 rounded-lg font-semibold text-white`}
                        style={{
                            backgroundColor:sellerColorDark,
                        }}>
                        <MdPayment size={24} />Start Payment Now
                    </button>
                    <div
                        className={` ${sellerBoolDepositShowPayments ? 'hidden' : 'font-semibold ml-4'} `} 
                        style={{color:sellerPrimaryColor1}} >
                        <div className='flex items-center justify-start gap-2 mb-4'>
                            <img width={20} height={20} src={success} alt="success" />
                            Thank You For Your Order
                            {get_cart_products_local()}
                        </div>
                        <div className='items-start justify-start mt-2 border'>   
                            <Link to={`/customerDashboard/myOrders`}   
                                className='px-5 py-2 border-2 cursor-pointer rounded-lg text-white' 
                                style={{
                                    color:sellerPrimaryColor1, 
                                    backgroundColor:sellerSecondaryColor1, 
                                    borderColor:sellerPrimaryColor1
                                }}>
                                Back To Customer Dashboard
                            </Link>
                       </div>
                    </div>
                </div>
            }
        </div>
    );
}; 

export default Stripe;





